import deliveryPointService from "../../../services/delivery-point/DeliveryPointService";
import i18n from "../../../i18n/index";


export default {
    data() {
        return {
            headers: [
                {
                    text: i18n.t('headers.name'),
                    sortable: false
                }, {
                    text: i18n.t('headers.state'),
                    sortable: false
                }, {
                    text: i18n.t('headers.city'),
                    sortable: false
                }, {
                    text: i18n.t('headers.address'),
                    sortable: false
                }, {
                    text: i18n.t('headers.status'),
                    sortable: false
                }
            ],
            deliveryPoints: [],
            search: '',
            totalDeliveryPoints: 0,
            loading: false,
            pagination: {}
        };
    },
    props: {},
    watch: {
        pagination: {
            handler() {
                this.getDeliveryPoints();
            },
            deep: true
        }
    },
    mounted() {

    },
    methods: {
        onRowClick(item) {
            this.$emit("row-click", item);
        },
        getDeliveryPoints() {
            this.loading = true;
            const { page, rowsPerPage } = this.pagination;
            deliveryPointService.getDeliveryPoints(
                page - 1,
                rowsPerPage,
                this.search
            ).then(data => {
                this.loading = false;
                this.deliveryPoints = data.data[0];
                this.totalDeliveryPoints = data.data[1];
            });
        }
    }
};
